<template>
  <div>
    <list
      row-key="OrderId"
      ref="list"
      unit="订单"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
         <el-form-item label="客户名称">
          <!-- <el-select v-model="params.CustomerId" size="mini">
            <el-option v-for="item in cList" :key="item.WholesalerId" :value="item.WholesalerId" :label="item.WholesalerName"></el-option>
          </el-select>-->
          <el-input
            v-model="params.CustomerName"
            @focus="addUnit"
            size="mini"
            readonly
            placeholder="请选择"
          ></el-input>
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.OrderNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="销售单状态">
          <el-select size="mini" v-model="params.SaleDocStatus" placeholder="请选择" clearable>
            <el-option label="已生成" :value="1"></el-option>
            <el-option label="未生成" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单来源">
          <el-select size="mini" v-model="params.Source" placeholder="请选择" clearable>
            <el-option label="线上" :value="1"></el-option>
            <el-option label="线下" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库状态">
          <el-select size="mini" v-model="params.OutStatus" placeholder="请选择" clearable>
            <el-option label="未出库" :value="0"></el-option>
            <el-option label="部分出库" :value="1"></el-option>
            <el-option label="已出库" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用优惠券">
          <el-select size="mini" v-model="params.CouponCustomerState" placeholder="请选择" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成状态">
          <el-select size="mini" v-model="params.CompleteStatus" placeholder="请选择" clearable>
            <el-option label="未完成" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款状态">
          <el-select size="mini" v-model="params.ReceiptStatus" placeholder="请选择" clearable>
            <el-option label="未收款" :value="0"></el-option>
            <el-option label="部分收款" :value="1"></el-option>
            <el-option label="已收款" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预计交货日期" label-width="100px">
          <el-date-picker
            size="mini"
            v-model.trim="params.DeliveryDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DeliveryDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
            <el-form-item label="参与活动">
          <el-select size="mini" v-model="params.PromotionType" placeholder="请选择" clearable>
            <el-option label="团购" :value="0"></el-option>
            <el-option label="秒杀" :value="1"></el-option>
            <el-option label="折扣" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="OrderNo" label="订单编号" min-width="160px" />
         <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">{{row.DocDate.split(" ")[0]}}</template>
        </el-table-column>
        <el-table-column prop="CustomerName" label="客户名称" min-width="170px" />
        <!-- <el-table-column prop="Address" label="客户信息" min-width="200px" show-overflow-tooltip /> -->
        <el-table-column prop="Amount" label="订单金额" />
        <el-table-column prop="ClerkName" label="业务员">
          <template slot-scope="{row}">{{row.ClerkName}}</template>
        </el-table-column>
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-else-if="row.Status==1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="OutStatus" label="出库状态">
          <template slot-scope="{row}">
            <span v-if="row.OutStatus==0">未出库</span>
            <span v-else-if="row.Status==1">部分出库</span>
            <span v-else>已出库</span>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptStatus" label="收款状态">
          <template slot-scope="{row}">
            <span v-if="row.ReceiptStatus==0">未收款</span>
            <span v-else-if="row.ReceiptStatus==1">部分收款</span>
            <span v-else>已收款</span>
          </template>
        </el-table-column>
        <el-table-column prop="CompleteStatus" label="完成状态">
          <template slot-scope="{row}">
            <span v-if="row.CompleteStatus==0">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="SaleDocStatus" label="销货单">
          <template slot-scope="{row}" @click="statusFun">
            <span v-if="row.SaleDocStatus==0">未生成</span>
            <span v-else>已生成</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
        <unit-dialog
      ref="unitDialog"
      in-dialog
      selectable
      @select="setUnit"
      title="客户列表"
      :typeList="[1,2]"
    />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";

export default {
  mixins: [listMixin],
  components: { list,unitDialog },
  props: {
    source: {
      default: null
    },
    billType:{
      default:null
    }
  },
  data() {
    return {
      api: require("@/api/sale/sales").default,
      goods_api: require("@/api/mall/orderGoods").default,
      params: {
        OrderNo: "",
        Status: null, //订单状态
        SendStatus: null, //发货状态
        PayStatus: null, //付款状态
        RefundStatus: null, //退款状态
        CustomerType: 0,
        CustomerName: "",
        CustomerId:"",
        Source:this.source,
        BillType:this.billType
      },
    };
  },
  methods: {
    setUnit(e) {
      
      this.params.CustomerId = e.Id;
      this.params.CustomerName = e.Name;
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    onExport() {
      this.goods_api.export(this.params);
    },
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>